module.exports = __webpack_public_path__ + "static/media/uwg_logo.def3c634.svg";